import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { Holodeck } from '@sloyd/ui';
import { bridge } from '@sloyd/viewer';
import { useMemo } from 'react';
import { $a } from 'shared-base';

type PopId = 'background' | 'grid' | 'ambience' | 'backdrop';
type ParamType = 'color' | 'intensity';

const holodeckMap = {
  grid: {
    color: 'gridLinesColor',
    intensity: 'gridLinesOpacity',
  },
  ambience: {
    color: 'lightColor',
    intensity: 'lightIntensity',
  },
  background: {
    color: 'backgroundColor',
    intensity: 'backgroundIntensity',
  },
  backdrop: {
    color: 'backdropId',
    intensity: '',
    enabled: 'backdropEnabled',
  },
  shader: {
    color: '',
    intensity: '',
  },
};

export type HolodeckProps = {
  instanceId: string;
};

export function HolodeckContainer(props: HolodeckProps) {
  const { instanceId = 'main' } = props;
  const dispatch = useDispatch();
  const holodeckState = useSelector(selectors.raw.$rawHolodeckState);
  const backdrops = useSelector(selectors.gallery.$backdrops);
  const shaders = useSelector(selectors.gallery.$shaders);

  const callbacks = useMemo(
    () => ({
      onChange: (popId: PopId, paramType: ParamType, value: string | number) => {
        if (popId === 'background') return;
        const key = holodeckMap[popId][paramType];
        if (key) bridge.patchEnvironment(instanceId, { [key]: value });
      },
      onSet: (popId: PopId, paramType: ParamType, value: string | number) => {
        const key = holodeckMap[popId][paramType];
        if (key) bridge.patchEnvironment(instanceId, { [key]: value });
        dispatch($a('HOLODECK', 'patch', '', { popId, paramType, value }));
      },
      onReset: () => {
        dispatch($a('HOLODECK', 'reset', ''));
      },
    }),
    [holodeckState]
  );

  return (
    <Holodeck
      holodeckState={holodeckState}
      onChange={callbacks.onChange}
      onSet={callbacks.onSet}
      onReset={callbacks.onReset}
      onGizmoSceneToggle={callbacks.onReset}
      backdrops={backdrops}
      shaders={shaders}
    />
  );
}

export default HolodeckContainer;
